import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Ĝi estas mola, glata, premobea, ĝi plene pretas trafi al la manoj de tiuj, kiuj povas aranĝi lian sorton. 
      En tiu tempo lin ne fortiras eĉ malpura konstruista laboro – spatelado.
    </p>
    
    <p class="mb-3">
      Sed jen li trovas sian fendon, penetras en ĝin kaj sekure akomodiĝas. 
      Kaj tuj en lia karaktero aperas novaj trajtoj: sekeco, necedemo kaj obstina firmeco.
    </p>
    `
  )
}

const itemName = {
  esp: 'La gipso'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;